const TEXT_CONTENT_BY_CATEGORY: {
  [key: string]: {
    metaTitle: string;
    metaDescription: string;
    displayTitle: string;
    displayDescription: string;
  };
} = {
  "": {
    metaTitle: "Orchid Blog | Mental Health Resources, Insights & Inspiration",
    metaDescription:
      "Gain valuable insights, learn practical tips, and discover the latest trends to build and grow your mental health practice. Stay inspired and informed with Orchid.",
    displayTitle: "Orchid Blog",
    displayDescription:
      "Resources for cultivating your mental healthcare practice",
  },
  "professional-development": {
    metaTitle: "Orchid Blog | Professional Development: Elevate Your Practice",
    metaDescription:
      "Enhance your skills and competencies. Dive into curated resources, articles, and expert advice tailored to elevate your mental health profession.",
    displayTitle: "The Orchid Blog: Professional Development Insights",
    displayDescription:
      "Sharpening Skills and Knowledge for a Thriving Mental Health Career",
  },
  "clinician-wellness": {
    metaTitle: "Orchid Blog | Clinician Wellness: Self-Care for Clinicians",
    metaDescription:
      "Prioritize self-care and well-being. Explore holistic approaches, tips, and strategies to maintain balance and resilience in your mental health career.",
    displayTitle: "The Orchid Blog: Wellness for the Healer",
    displayDescription:
      "Fostering Resilience and Balance for Mental Health Professionals",
  },
  "industry-research": {
    metaTitle:
      "Orchid Blog | Industry Research: Cutting-Edge Clinical Insights",
    metaDescription:
      "Stay ahead of the curve. Dive into the latest studies, findings, and trends shaping the future of mental health practice.",
    displayTitle: "The Orchid Blog: Mental Health Research & Trends",
    displayDescription: "Unlocking the Future of Comprehensive Care",
  },
  "in-the-news": {
    metaTitle: "Orchid Blog | In The News: Latest Updates in Mental Health",
    metaDescription:
      "Stay updated with breaking news, latest events, and spotlight features that shape the mental health sector. Be informed and in the loop with Orchid.",
    displayTitle: "The Orchid Blog: Mental Health News & Highlights",
    displayDescription:
      "Stay Informed with the Latest Updates and Developments",
  },
  resources: {
    metaTitle:
      "Orchid Blog | Resources: Essential Tools & Guides for Clinicians",
    metaDescription:
      "Access a curated collection of tools, articles & guides designed to support and enhance your clinical practice. Your one-stop hub with Orchid.",
    displayTitle: "The Orchid Blog: Essential Resources Hub",
    displayDescription: "Tools, Articles, and Guides to Amplify Your Practice",
  },
};

export default TEXT_CONTENT_BY_CATEGORY;
